import { useEffect as u, useRef as n } from "react";
import { microTask as o } from '../utils/micro-task.js';
import { useEvent as f } from './use-event.js';
function c(t) {
  var r = f(t),
    e = n(!1);
  u(function () {
    return e.current = !1, function () {
      e.current = !0, o(function () {
        e.current && r();
      });
    };
  }, [r]);
}
export { c as useOnUnmount };